import { NgModule } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from '@angular/common';
//import "froala-editor/js/froala_editor.pkgd.min.js";
import { FroalaEditorModule, FroalaViewModule } from "angular-froala-wysiwyg";

import { WellDetailsComponent } from './well-details/well-details.component';
import { WellResolver } from './resolvers/well.resolver';
import { LunaCommonModule } from '../common/common.module';
import { DataTableModule } from '../common/components/data-table/data-table.module';
import { WellDetailsModalComponent } from './well-details/well-details-modal/well-details-modal.component';
import { AccordionModule } from "../common/components/accordion/accordion.module";
import { OnBaseWellDocumentsComponent } from './well-details/well-documents/onbase-well-documents.component';
import { IssuesModule } from '../issues/issues.module';
import { LandownerPassthroughDetailsComponent } from './well-details/landowner-passthrough-details/landowner-passthrough-details.component';
import { WellNotesComponent } from './well-notes/well-notes.component';
import { ComplianceDatesComponent } from './well-details/compliance-dates/compliance-dates.component';
import { StratigraphicWellBondingComponent } from './well-details/stratigraphic-well-bonding/stratigraphic-well-bonding.component';
import { StratigraphicBondingEditorComponent } from './well-details/stratigraphic-well-bonding/stratigraphic-bonding-editor/stratigraphic-bonding-editor.component';
import { WellDetailFormationsComponent } from './well-details/well-detail-formations/well-detail-formations.component';
import { WellDetailCasingStringsComponent } from './well-details/well-detail-casing-strings/well-detail-casing-strings.component';
import { EditFormationRecordComponent } from './well-details/edit-formation-record/edit-formation-record.component';
import { EditCasingTubingRecordComponent } from './well-details/edit-casing-tubing-record/edit-casing-tubing-record.component';


@NgModule({
    imports: [
        CommonModule,
        AgGridModule,
        LunaCommonModule,
        DataTableModule,
        AccordionModule,
        IssuesModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        ReactiveFormsModule,
        FormsModule
    ],
    declarations: [
        WellDetailsComponent,
        WellDetailsModalComponent,
        OnBaseWellDocumentsComponent,
        LandownerPassthroughDetailsComponent,
        WellNotesComponent,
        ComplianceDatesComponent,
        StratigraphicWellBondingComponent,
        StratigraphicBondingEditorComponent,
        WellDetailFormationsComponent,
        WellDetailCasingStringsComponent,
        EditFormationRecordComponent,
        EditCasingTubingRecordComponent
    ],
    providers: [
        WellResolver
    ],
    exports: [
        WellDetailsComponent,
        WellDetailsModalComponent,
        WellNotesComponent
    ]
})
export class WellsModule { }
